import { Box, Center } from "@chakra-ui/react";
import { Map } from "components/Organismos/Map";
import { ClickPointControl } from "components/Organismos/Map/Controls/ClickPointControl";
import { IconNav } from "layouts/components/IconNav";
import { UserDescription } from "layouts/components/UserDescription";
import { LatLng, Map as LeafletMap } from "leaflet";
import { forwardRef, useImperativeHandle, useState } from "react";
import { TileLayer } from "react-leaflet";
import { useQueryParam } from "utils/hooks/useQueryParam";
import { wait } from "utils/wait";

const initialLatLng = new LatLng(1.252367, -51.946561);

type NewComplaintTemplateProps = {
    children: React.ReactNode;
    onMarkerChoose?: (latLng: LatLng) => void;
}

const NewComplaintTemplate = forwardRef<LeafletMap | undefined, NewComplaintTemplateProps>(({
    children,
    onMarkerChoose
}, ref) => {
    const [map, setMap] = useState<LeafletMap>();
    const [, setLat] = useQueryParam<number>('lat');
    const [, setLng] = useQueryParam<number>('lng');

    useImperativeHandle(ref, () => map);

    return (
        <Box position="relative" width="100%" height="100%">
            <Map center={initialLatLng}                
                zoom={7}
                zoomControl
                whenCreated={(ref) => setMap(ref)}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"                    
                />
                {children}
                <div className="leaflet-top leaflet-right">
                    <div className={`leaflet-control leaflet-bar`}>
                        <Center p={3}>
                            <IconNav />
                            <UserDescription showName />
                        </Center>
                    </div>
                </div>
                <Box className="leaflet-top leaflet-left" mt={70}>
                    <ClickPointControl
                        onMarkerChange={async (latLng) => {
                            setLat(latLng.lat);
                            await wait(100);
                            setLng(latLng.lng);
                            await wait(100);
                            onMarkerChoose?.(latLng);
                        }}
                    />
                </Box>
            </Map>
        </Box>
    )
});

export default NewComplaintTemplate